<template>
    <v-dialog
      v-model="dialog"
      width="500"
      scrollable>
      <template v-slot:activator="{ on }">
         <v-btn  v-on="on" color="secondary"><v-icon class='pr-2'>mail</v-icon>Send a message</v-btn>
      </template>
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title>Send a message</v-card-title>
        <v-card-text class='pt-5'>
        <v-text-field
          v-model='message_to'
          label="Recipient"
          readonly
          outlined></v-text-field>
          <v-text-field
          v-model='messageSubject'
          label="Subject"
          outlined></v-text-field>
        <v-textarea
          outlined
          v-model='messageBody'
          name="input-7-4"
          label="Message Body"
          placeholder="Enter message here"></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled='messageBody === null || messageBody === "" || messageSubject === null || messageSubject == ""'
            color="primary"
            text
            @click="sendMessage()">
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import  shortid  from 'shortid';
import { mapFields } from 'vuex-map-fields';
import { sendNewMessage } from '../../helper/firestore'

  export default {
    data () {
      return {
        messageSubject : null,
        subject : ["Non-Urgent Medical Question","Test Result Question","After Visit Question"],
        title : null,
        messageBody : null,
        message_to : "Genetic Trust Care Team",
        dialog: false,
      }
    },
    computed : {
      ...mapFields([
        'messages',
        'user',
        'snackBarshow',
        'snackBarType',
        'snackBarmessage',
      ]),
    },
    methods : {
      prepareMessage(){
        this.message = {
        messageType : "non-system",
        message_from: this.user.email,
        messageID : shortid.generate(),
        createdAt :  this.$moment().format("MM/DD/YYYY HH:mm:ss"),
        messageBody : this.messageBody,
        read : true,
        title : this.messageSubject,
        message_to : {
          uid : null,
          email : this.message_to
          },
          message_from : {
          uid : this.user.uid,
          email : this.user.email
          }
        }
      },
      sendMessage(){
        this.prepareMessage()
        sendNewMessage(this.message, ()=>{
          this.snackBarType = "success"
          this.snackBarshow = true
          this.snackBarmessage = "message sent"
          this.messageBody = null;
          this.title = this.messageSubject;
        })
        this.dialog = false
      },
    }
  }
</script>

<style>

</style>
